/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    let blocks: Array<CodeBlock> = [];
    const REGISTERS = feature.getSettingValue('REGISTERS');
    const NAME = feature.getSettingValue('NAME');
    const DEVICEID = feature.getSettingValue('DEVICEID');
    const DEVICEIP = feature.getSettingValue('DEVICEIP');
    const DEVICEPORT = feature.getSettingValue('DEVICEPORT');
    const { project } = feature;
    const PROTOCOL = feature.getSettingValue('PROTOCOL');
    let address = DEVICEID;
    if (PROTOCOL === 'modbus_TCP') {
        address = `"${DEVICEIP}:${DEVICEPORT}"`;
    }
    let SERIAL_PORT;
    const featureId = feature.getID();
    const INTERFACE = 'current_interface';

    blocks.push({
        location: 'modbus_master_request_devices_init',
        blockType: BlockType.CODE,
        template: `
        ${address}: {
            /****modbus_master_request_${featureId}_registers_init****/
        },
        `,
    });

    for (let i = 0; i < REGISTERS.length; i += 1) {
        blocks = blocks.concat(REGISTERS[i].getCodeBlocks());
    }

    return blocks;
};
